import fetch from "./action.fetch";
import { FETCH_SYSTEMS } from "./action.types";


export const fetchSystems = () =>
    fetch({
        url: '/systems',
        actionType: FETCH_SYSTEMS
});